import { useLocation } from 'react-router-dom';

import GlobalDialog from 'components/Common/GlobalDialog';

const GlobalDialogWithLocation = () => {
    const location = useLocation();
    return <GlobalDialog location={location} />;
};

export default GlobalDialogWithLocation;
